function getP(): any
{
  return ( window as any )?.Capacitor?.Plugins?.DevToDev ?? null;
}

export const DevToDev = {
  async sendEvent( name: string, params?: Record<string, any> ): Promise<void>
  {
    const p = getP();
    if ( !p )
    {
      console.warn( '[DevToDev] plugin not available' );
      return;
    }
    try
    {
      if ( params )
      {
        await p.customEvent( { name, params } );
        console.log( `[DevToDev] ✅ Event sent: ${name}`, params );
      }
      else
      {
        await p.customEvent( { name } );
        console.log( `[DevToDev] ✅ Event sent: ${name}` );
      }
    } catch ( e )
    {
      console.error( '[DevToDev] sendEvent failed:', e );
    }
  },

  async playClicked( mode: 'normal' | 'difficult' ): Promise<void>
  {
    await this.sendEvent( `play_button_click_${mode}` );
  },

  appStart(): Promise<void> { return this.sendEvent( 'app_start' ); },
  firstScreenShown( ms: number ): Promise<void> { return this.sendEvent( `app_first_screen_${Math.round( ms )}ms` ); },

  backButton( result: 'goBack' | 'exit' | 'close_dialog' ): Promise<void> { return this.sendEvent( `back_button_${result}` ); },
  exitConfirmShown(): Promise<void> { return this.sendEvent( 'exit_confirm_shown' ); },
  exitConfirmResult( ok: boolean ): Promise<void> { return this.sendEvent( `exit_confirm_result_${ok ? 'ok' : 'cancel'}` ); },
};
